import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import moment from "moment";
import Modal from "./blog_modal";
import { handleImageModal } from "./blog_modal";
import ErrorPage from "./error_page";
import SongComponent from "./song";
import GoogleMap from "./map";
import { FormattedCategory } from "./utilities/category";

export default function SinglePost({ posts }) {
  const [modalState, setModalState] = useState(false);
  let { postId } = useParams();

  if (!posts) {
    return (
      <p>Loading...</p>
    );
  }

  // function handleImageModal(id) {
  //   return setModalState(id);
  // }

  let post = {};
  if (posts) {
    posts.forEach((p) => {
      if (p.nid == postId) {
        post = p;
      }
    });
  }
  // Make image CSV into an array
  post.post_images_array = post.post_images.replaceAll(' ','').split(',');
  post.post_images_preview_array = post.post_images_preview.replaceAll(' ','').split(',');

  // Have gifs render full size
  post.post_images_preview_array.map((img, index) => {
    if (img.includes('.gif')) {
      post.post_images_preview_array[index] = post.post_images_array[index];
    }
  });

  // Get song hash from post.post_song
  if (post.post_song.length > 0) {
    let song = post.post_song.split('/');
    post.song_id = song[song.length - 1].split('?')[0];
  }

  // Structure Lat and Long
  if (post.lat_long.length > 0) {
    post.lat_long_formatted = [];
    let entries = post.lat_long.split('|')
    entries.forEach((ll)=>{
      let ll_array = ll.split(',');
      post.lat_long_formatted.push({lat: Number(ll_array[0].replaceAll(' ','')), lng: Number(ll_array[1].replaceAll(' ',''))})
    })
  }

  // Format Post Categories
  post.categories = post.category.split(', ');

  function no_bitches(marker = "beginning") {
    function render_buttons(marker) {
      if (marker == "beginning") {
        return (
          <Link
            className="button"
            to={`/parry_news/post/${Number(postId) - 1}`}
          >
            Next Post
          </Link>
        );
      }
      if (marker == "end") {
        return (
          <Link
            className="button"
            to={`/parry_news/post/${Number(postId) - 1}`}
          >
            Prev Post
          </Link>
        );
      }
    }
    return (
      <>
        <div className="post-item-wrapper">
          <p>You&apos;ve reched the end of the line, partner...</p>
        </div>
        <div className="button-wrapper">
          {/* <button onClick={handleClose}>Back to List</button> */}
          {render_buttons(marker)}
        </div>
      </>
    );
  }
  function post_structure() {
    return (
      <>
        <div className="post-item-wrapper">
          <div className="the-post">
            <div className="post-header">
              <h2>{post.title}</h2>
              <Link className="button" to={`/parry_news/`}>
                Back to List
              </Link>
            </div>
            {/* <div className="post-song-wrapper"> */}
            {/*   <iframe  */}
            {/*     className="post-song"  */}
            {/*     src="https://open.spotify.com/embed/track/36Us7iQfslxRe1sOqUDmyt?utm_source=generator"  */}
            {/*     width="100%"  */}
            {/*     height="352"  */}
            {/*     // frameBorder="0"  */}
            {/*     allowfullscreen=""  */}
            {/*     allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"  */}
            {/*     // loading="lazy" */}
            {/*   ></iframe> */}
            {/* </div> */}
            <div className="post-info">
              {post.category.length > 0 ? (
                <div className="post-tags">
                  <p className="post-categories">
                    {post.categories.map((category, index) => {
                      return <FormattedCategory category={category} key={index} />;
                    })}
                  </p>
                  <p className="spanner">/</p>
                </div>
              ) : null}
              {post.occurrence_date.length > 0 ? (
                <div className="post-date-wrapper">
                  <p className="post-occurrence-date">
                    {moment(post.occurrence_date).fromNow()}
                  </p>
                  <p className="spanner middle">/</p>
                  <p className="raw-occurrence-date">
                    {post.occurrence_date}
                  </p>
                </div>
              ) : null}
            </div>
            {post.lat_long_formatted ? 
              <GoogleMap coordinates={post.lat_long_formatted} name={post.name}/>
            : null}
            <div className="post-body">
              <div
                dangerouslySetInnerHTML={{ __html: post.body }}
              ></div>
            </div>
            <div className="post-author">
              Authored by {post.name} 
              <span dangerouslySetInnerHTML={{ __html: post.created }}></span></div>
            {post.post_images_preview_array.length > 0 ? (
              <div className="post-images">
                {post.post_images_preview_array.map((image, index) => (
                  // {if (image[:-3] == "gif") {
                  //   image = post.post_images_array[index];
                  // }}
                    <img
                      key={index}
                      className="post-image"
                      style={{ width: "100%" }}
                      src={`https://cms.madebyparry.com${image}`}
                      onClick={() => handleImageModal({
                      image: `https://cms.madebyparry.com${post.post_images_array[index]}`,
                      index: index
                    }, setModalState)}
                    />
                ))}
              </div>
            ) : null}
            {post.post_song ?
              <SongComponent songId={post.song_id}/>
              : null}
          </div>
          <div className="post-footer">
            <Link className="button" to={`/parry_news/`}>
              Back to List
            </Link>
          </div>
        </div>
        {/* <div className="button-wrapper"> */}
        {/*   <Link className="button" to={`/news/`}> */}
        {/*     Back to List */}
        {/*   </Link> */}
        {/*   <Link className="button" to={`/news/post/${Number(postId) - 1}`}> */}
        {/*     Prev Post */}
        {/*   </Link> */}
        {/*   <Link className="button" to={`/news/post/${Number(postId) + 1}`}> */}
        {/*     Next Post */}
        {/*   </Link> */}
        {/* </div> */}
        <Modal modalState={modalState} setModalState={setModalState} imageList={post.post_images_array} />
      </>
    );
  }
  if (postId == 0) {
    return no_bitches("beginning");
  } else if (posts) {
    return post_structure();
  } else {
    return <p>Loading</p>;
  }
}
